export default __webpack_public_path__ + "static/media/warning--atv-crossing--g2.4048703b.png";